import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-switch-admin',
  templateUrl: './home-switch-admin.component.html',
  styleUrls: ['./home-switch-admin.component.scss']
})
export class HomeSwitchAdminComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
